import Skeleton from 'react-loading-skeleton';

import ToggleButton from 'components/common/ToggleButton';

const BoxQuestionsToggles = ({ boxSignupData, handleBoxSignupAnswerClick, icons, pathname }) => {
  if (!boxSignupData?.answers) {
    return (
      <>
        <Skeleton count={3} className="my-1" height={32} />
        <Skeleton count={1} className="my-8" height={48} />
      </>
    );
  }

  const isMealtimesQuestion =
    boxSignupData.question === 'What meals do you want Home Chef to cover?';

  return (
    <>
      <div className="mb-4 bp1:mb-0">
        {boxSignupData.answers.map(answer => (
          <div key={answer.name}>
            <ToggleButton
              id={answer.id}
              renderIconMultipleTimes={answer.value}
              selected={answer.selected}
              handleClick={() => handleBoxSignupAnswerClick(answer)}
              className="mb-2 w-full px-4 py-4 text-left"
              type="boxRecommender"
              role={isMealtimesQuestion ? 'checkbox' : 'radio'}
              icon={isMealtimesQuestion ? icons.iconMap[answer.name] : icons.iconMap[pathname]}
              textContainerClassName="flex w-full items-center justify-between bp1:w-112"
            >
              {answer.name}
            </ToggleButton>
          </div>
        ))}
      </div>
    </>
  );
};

BoxQuestionsToggles.propTypes = {
  boxSignupData: PropTypes.object,
  handleBoxSignupAnswerClick: PropTypes.func,
  icons: PropTypes.object,
  pathname: PropTypes.string,
};

export default BoxQuestionsToggles;
